import { SVGProps } from "react";

export const TutorialArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 108 105"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#tutorial-arrow-a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.67 36.42c-1.338 1.336-1.46 3.381-.272 4.568l15.757 15.758 2.149 2.148L28.568 70.63c-2.009 2.008-1.097 5.19 1.541 5.377l49.59 3.529c2.087.148 3.985-1.75 3.837-3.836l-3.529-49.59c-.187-2.639-3.369-3.55-5.377-1.542L62.894 36.303l-2.148-2.148-15.758-15.758c-1.186-1.186-3.232-1.064-4.569.272L22.67 36.42Z"
        fill="#FC6560"
      />
      <path
        d="m41.718 60.308 1.414-1.414-1.414-1.414-.003-.003-.008-.008-.033-.033-.125-.125-.46-.46-1.52-1.52-15.757-15.757c-.252-.252-.447-1.022.271-1.74l17.75-17.75c.72-.72 1.489-.524 1.741-.272l15.757 15.757.007.007.007.007.007.007.007.007.007.007.007.007.007.007.007.006.007.007.007.007.006.007.007.007.007.007.007.007.007.007.007.007.007.006.007.007.006.007.007.007.007.007.007.007.007.007.007.006.007.007.006.007.007.007.007.007.007.006.007.007.006.007.007.007.007.006.007.007.006.007.007.007.007.006.007.007.006.007.007.007.007.006.006.007.007.007.007.007.007.006.006.007.007.007.007.006.006.007.007.007.007.006.006.007.007.006.007.007.006.007.007.006.006.007.007.007.006.006.007.007.007.006.006.007.007.007.006.006.007.007.007.006.006.007.007.006.006.007.007.006.006.007.007.006.006.007.007.006.006.007.007.006.006.007.007.006.006.007.006.006.007.006.006.007.007.006.006.007.006.006.007.007.006.006.007.006.006.007.006.006.007.006.006.007.006.006.007.006.006.007.006.006.007.006.006.007.006.006.007.006.006.006.006.007.006.006.006.006.007.006.006.007.006.006.006.006.007.006.006.006.006.007.006.006.006.006.007.006.006.006.006.006.006.007.006.006.006.006.006.006.006.006.006.006.007.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.006.005.006.006.006.006.006.006.006.006.006.006.006.006.006.006.005.006.006.006.006.005.006.006.006.006.006.006.005.006.006.005.006.006.006.006.006.006.005.005.006.006.006.006.005.006.006.005.006.006.006.006.005.005.006.006.006.006.005.005.006.006.005.005.006.006.006.006.005.005.006.006.005.005.006.006.006.006.005.005.006.006.005.005.006.006.005.005.006.006.005.005.006.005.005.006.006.005.005.006.005.005.006.006.005.005.006.005.005.006.005.005.006.005.005.006.005.005.006.005.005.006.005.005.006.005.005.005.005.006.005.005.006.005.005.005.005.006.005.005.005.005.006.005.005.005.005.005.005.006.005.005.005.005.005.005.006.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.005.004.005.005.005.005.004.005.005.005.005.005.005.005.005.004.005.005.004.005.005.005.005.005.005.004.004.005.005.005.005.004.005.005.004.005.005.005.005.004.004.005.005.004.004.005.005.005.005.004.004.005.005.004.004.005.005.004.004.005.005.005.004.004.005.005.004.004.005.004.004.005.005.004.004.005.004.004.005.005.004.004.005.004.004.005.004.004.005.004.004.005.004.004.004.004.005.004.004.005.004.004.004.004.005.004.004.004.004.005.004.004.004.004.004.004.004.004.005.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.004.003.004.004.004.004.004.004.004.004.004.004.003.004.004.003.004.004.004.004.004.004.003.003.004.004.004.004.004.004.003.003.004.004.003.003.004.004.004.004.003.003.004.004.004.003.003.004.004.004.003.003.004.004.003.003.004.003.003.004.004.003.003.004.004.003.003.004.003.003.004.003.003.004.003.003.004.003.003.004.003.003.003.003.004.003.003.004.003.003.004.003.003.003.003.003.003.004.003.003.003.003.003.003.004.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.003.002.003.003.003.003.002.003.003.003.003.003.003.002.003.003.002.003.003.003.003.002.003.003.002.003.003.003.003.002.002.003.003.002.002.003.003.003.003.002.002.003.003.002.002.003.003.002.002.003.003.002.002.003.003.002.002.003.002.002.003.003.002.002.002.002.003.002.002.003.002.002.003.002.002.003.002.002.002.002.003.002.002.002.002.003.002.002.002.002.002.002.002.002.002.002.003.002.002.002.002.002.002.002.002.002.001.002.002.002.002.002.002.002.002.002.002.002.002.001.002.002.001.002.002.002.002.002.002.001.001.002.002.002.002.001.001.002.002.002.002.001.001.002.002.002.002.001.001.002.002.001.001.002.002.001.001.002.002.001v.002l.002.001.002.001.001.002.001.001.002.001.001.002.001.001.002.001v.002h.002l.001.002.002.001v.001l.002.002h.001l.001.002h.001l.001.002h.001l.001.002.001.001.001.001h.001l.001.002h.001l.001.002.002.002.002.001.001.002.002.001.001.002.001.001.002.001v.001h.001v.002h.002v.001h.001v.001h.001v.001h.001v.001h.001v.001h.001l1.414 1.415 1.414-1.414 11.736-11.736c.507-.507 1.058-.563 1.406-.463.177.05.304.14.387.238.076.091.157.24.175.494l3.529 49.59c.062.873-.827 1.762-1.7 1.7l-49.59-3.529c-.254-.018-.402-.099-.494-.175a.772.772 0 0 1-.238-.387c-.1-.348-.044-.899.463-1.406l11.736-11.736Z"
        stroke="#FEFDFE"
        strokeWidth={4}
      />
    </g>
    <defs>
      <filter
        id="tutorial-arrow-a"
        x={0.581}
        y={0.582}
        width={103.963}
        height={103.962}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={3}
          operator="dilate"
          in="SourceAlpha"
          result="effect1_dropShadow_3214_28529"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={9} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_3214_28529"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="dilate"
          in="SourceAlpha"
          result="effect2_dropShadow_3214_28529"
        />
        <feOffset dy={10} />
        <feGaussianBlur stdDeviation={7} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0" />
        <feBlend
          in2="effect1_dropShadow_3214_28529"
          result="effect2_dropShadow_3214_28529"
        />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={3}
          in="SourceAlpha"
          result="effect3_dropShadow_3214_28529"
        />
        <feOffset dy={6} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend
          in2="effect2_dropShadow_3214_28529"
          result="effect3_dropShadow_3214_28529"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect3_dropShadow_3214_28529"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
